import {useEffect} from 'react';

import {useClient, useConversation} from '../../core/hooks/appHooks';

export function useRestartConversationEvents() {
  const client = useClient();
  const {restartConversation} = useConversation();

  useEffect(() => {
    // have to use the client conversationEventsObservable instead of the
    // conversation events, because those stop emitting once the conversation
    // ends, which would be true in this case
    const sub = client.conversationEventsObservable().subscribe((event) => {
      if (
        event.name === 'conversation-set-context-values' &&
        !!event.values.restartConversation
      ) {
        const restartConversationParams = event.values.restartConversation;
        restartConversation({
          initialQuery: restartConversationParams.initialQuery,
        });
      }
    });
    return () => sub.unsubscribe();
  }, [client, restartConversation]);
}
